// extracted by mini-css-extract-plugin
export default {"accordionSummary":"NavSection_accordionSummary__oPKQ0","accordion":"NavSection_accordion__yf4Zh","accordionDetails":"NavSection_accordionDetails__gF+6J"};